import { withInstall } from '@code-monkey-ui/utils'
import CheckTag from './src/check-tag.vue'

export const ElCheckTag = withInstall(CheckTag)
export default ElCheckTag

export * from './src/check-tag'
